module.exports = __webpack_public_path__ + "img/Vector8.ba25fead.svg";